import { isInternalListTimelineItem } from 'flow-doctor-lib/utils/listMembershipTimelineUtils';
const externalFilterStrategy = item => {
  switch (item.type) {
    case 'LIST_MEMBERSHIP_WITH_VISIBILITY':
      return !isInternalListTimelineItem(item);
    default:
      return true;
  }
};
const internalFilterStrategy = __item => true;
const FilterStrategies = {
  INTERNAL: internalFilterStrategy,
  EXTERNAL: externalFilterStrategy
};
export const getTimelineFilterStrategy = strategy => {
  return FilterStrategies[strategy];
};